export default () => window.sessionStorage;
